import React from 'react'
import { Box } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import ClearIcon from '@mui/icons-material/Clear'

const ArtosToggle = ({ 
    checked = false,
    onChange,
    showIcons = false,
    activeColor = '#3b82f6',
    inactiveColor = '#e5e7eb',
    iconActiveColor = '#9CA3AF',
    iconInactiveColor = '#9CA3AF',
    size = 'default',
    disabled = false,
    sx = {}
}) => {
    const sizes = {
        default: {
            container: { width: '40px', height: '22px' },
            thumb: { width: '18px', height: '18px', translateActive: '20px', translateInactive: '2px' },
            icon: { width: '12px', height: '12px', fontSize: '12px' }
        },
        small: {
            container: { width: '36px', height: '20px' },
            thumb: { width: '16px', height: '16px', translateActive: '18px', translateInactive: '2px' },
            icon: { width: '10px', height: '10px', fontSize: '10px' }
        },
        large: {
            container: { width: '52px', height: '28px' },
            thumb: { width: '24px', height: '24px', translateActive: '26px', translateInactive: '2px' },
            icon: { width: '14px', height: '14px', fontSize: '14px' }
        }
    }

    const currentSize = sizes[size] || sizes.default

    const handleClick = () => {
        if (!disabled && onChange) {
            onChange(!checked)
        }
    }

    return (
        <Box
            onClick={handleClick}
            sx={{
                width: currentSize.container.width,
                height: currentSize.container.height,
                backgroundColor: checked ? activeColor : inactiveColor,
                borderRadius: '12px',
                position: 'relative',
                cursor: disabled ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.3s ease',
                opacity: disabled ? 0.6 : 1,
                display: 'flex',
                alignItems: 'center',
                padding: showIcons ? '2px' : '0',
                ...sx
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    left: checked ? currentSize.thumb.translateActive : currentSize.thumb.translateInactive,
                    top: '2px',
                    width: currentSize.thumb.width,
                    height: currentSize.thumb.height,
                    backgroundColor: '#ffffff',
                    borderRadius: '10px',
                    transition: showIcons ? 'transform 0.3s ease' : 'left 0.2s',
                    transform: showIcons && checked ? `translateX(0)` : undefined,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: showIcons ? '4px' : '0',
                    boxSizing: 'border-box'
                }}
            >
                {showIcons && (
                    checked ? (
                        <CheckIcon 
                            sx={{ 
                                fontSize: currentSize.icon.fontSize, 
                                color: iconActiveColor,
                                width: currentSize.icon.width,
                                height: currentSize.icon.height
                            }} 
                        />
                    ) : (
                        <ClearIcon 
                            sx={{ 
                                fontSize: currentSize.icon.fontSize, 
                                color: iconInactiveColor,
                                width: currentSize.icon.width,
                                height: currentSize.icon.height
                            }} 
                        />
                    )
                )}
            </Box>
        </Box>
    )
}

export default ArtosToggle